import { MuiAlert } from './components/MuiAlert'
import { MuiAppBar } from './components/MuiAppBar'
import { MuiAutocomplete } from './components/MuiAutocomplete'
import { MuiButton } from './components/MuiButton'
import { MuiButtonGroup } from './components/MuiButtonGroup'
import { MuiCardHeader } from './components/MuiCardHeader'
import { MuiCheckbox } from './components/MuiCheckbox'
import { MuiChip } from './components/MuiChip'
import { MuiContainer } from './components/MuiContainer'
import { MuiDialog } from './components/MuiDialog'
import { MuiDialogActions } from './components/MuiDialogActions'
import { MuiDialogContent } from './components/MuiDialogContent'
import { MuiDialogTitle } from './components/MuiDialogTitle'
import { MuiDivider } from './components/MuiDivider'
import { MuiDrawer } from './components/MuiDrawer'
import { MuiFab } from './components/MuiFab'
import { MuiFormControl } from './components/MuiFormControl'
import { MuiFormControlLabel } from './components/MuiFormControlLabel'
import { MuiFormHelperText } from './components/MuiFormHelperText'
import { MuiFormLabel } from './components/MuiFormLabel'
import { MuiIconButton } from './components/MuiIconButton'
import { MuiInputBase } from './components/MuiInputBase'
import { MuiInputLabel } from './components/MuiInputLabel'
import { MuiLinearProgress } from './components/MuiLinearProgress'
import { MuiMenu } from './components/MuiMenu'
import { MuiOutlinedInput } from './components/MuiOutlinedInput'
import { MuiPaper } from './components/MuiPaper'
import { MuiRadio } from './components/MuiRadio'
import { MuiSelect } from './components/MuiSelect'
import { MuiSwitch } from './components/MuiSwitch'
import { MuiTab } from './components/MuiTab'
import { MuiTabs } from './components/MuiTabs'
import { MuiTextField } from './components/MuiTextField'
import { MuiToggleButtonGroup } from './components/MuiToggleButtonGroup'

declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    neutralDark: true
    neutralLight: true
    neutral: true
  }
}

declare module '@mui/material/Chip' {
  interface ChipPropsVariantOverrides {
    filled: false
  }

  interface ChipPropsColorOverrides {
    neutral: true
  }

  interface ChipPropsSizeOverrides {
    tiny: true
    large: true
  }
}

declare module '@mui/material/CircularProgress' {
  interface CircularProgressPropsColorOverrides {
    neutralDark: true
    neutralLight: true
    neutral: true
  }
}

declare module '@mui/material/SvgIcon' {
  interface SvgIconPropsColorOverrides {
    neutralDark: true
    neutralLight: true
    neutral: true
  }
}

export const MuiComponentOverrides = {
  MuiCardHeader,
  MuiAppBar,
  MuiPaper,
  MuiDrawer,
  MuiButton,
  MuiButtonGroup,
  MuiToggleButtonGroup,
  MuiCheckbox,
  MuiFab,
  MuiDivider,
  MuiFormControl,
  MuiFormHelperText,
  MuiIconButton,
  MuiFormLabel,
  MuiInputBase,
  MuiInputLabel,
  MuiLinearProgress,
  MuiOutlinedInput,
  MuiRadio,
  MuiSwitch,
  MuiTextField,
  MuiFormControlLabel,
  MuiAlert,
  MuiSelect,
  MuiAutocomplete,
  MuiDialog,
  MuiDialogContent,
  MuiDialogActions,
  MuiDialogTitle,
  MuiMenu,
  MuiChip,
  MuiContainer,
  MuiTabs,
  MuiTab,
}
